import * as React from 'react';

import { longFormatDate } from '@/utils/dates';

const useSSRFriendlyDate = (componentDate) => {
    const [date, setDate] = React.useState('');

    React.useEffect(() => {
        setDate(longFormatDate(componentDate));
    }, [componentDate]);

    return date;
};

export default useSSRFriendlyDate;
